import './style.scss';
let $descTips = null;

export const $desc = (opts) => {
  $descTips && $descTips.$desc(opts);
};

export default {
  data() {
    return {
      descTips: [],
    };
  },
  created() {
    $descTips = this;
  },
  props: {
    max: {
      type: Number,
      default: 1,
    }
  },
  methods: {
    $desc(descItem) {
      const descTips = [...this.descTips];
      descTips.unshift(descItem);
      this.descTips = [...descTips.slice(0, this.max)];
    },
  },
  render() {
    return !!this.descTips.length && (
      <div class="config-desc-slot">
        { this.descTips }
      </div>
    );
  }
}
